
IREP.BadgePromo = (function () {

    var init = function () {
        
        var referDisplay = true;
        //var referTarget = $('#ReferralHolder').offset().top;

      

        var numRefs = $("#bp").find(".referredRow");
        var newheight = 200;
       // alert(newheight);
        $("#bp").find('.content').css("height", newheight);
        $("#bp").css("height", $("#bp").find('.content').outerHeight() + $("#bp").find('.header').outerHeight());
        

        $("#bp").find('[data-actions~="band-toggle-footer"]').click(function (e) {
            e.preventDefault();
            if (self.toggleState === 1) {
                TweenLite.to($("#bp").find('.content'), 1, { height: newheight });
                self.toggleState = 0;
            } else {
                var el = $("#bp").find('.content'),
                curHeight = el.height(),
                autoHeight = el.css('height', 'auto').height();
                el.height(curHeight);
              //  el.height(curHeight).animate({ height: autoHeight }, 400);
                TweenLite.to(el, 1, { height: autoHeight });
                self.toggleState = 1;
            }
        });

       

        $("#bp").find('[data-actions~="band-open-footer"]').click(function (e) {
            e.preventDefault();
            TweenLite.to($("#bp").find('.content'), 1, { height: "100%" });
            self.toggleState = 1;
        });

        $("#bp").find('[data-actions~="band-close-footer"]').click(function (e) {
            e.preventDefault();
            TweenLite.to($("#bp").find('.content'), 1, { height: newheight });
            self.toggleState = 0;
        });


        
    }

    return {
        init: init
    };
})();